interface CheckForExistenceProps {
  arrayData: string[] | number[];
  phrase: string | number;
}

const checkForExistenceInArray = ({ arrayData, phrase }: CheckForExistenceProps): boolean =>
  !arrayData || arrayData.includes(phrase as never);

export default checkForExistenceInArray;
